/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_TitleInputs */

const en_us2_profile_editors_pain_title = /** @type {(inputs: Profile_Editors_Pain_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where does it hurt?`)
};

const pt_br2_profile_editors_pain_title = /** @type {(inputs: Profile_Editors_Pain_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde está doendo?`)
};

const es_419_profile_editors_pain_title = /** @type {(inputs: Profile_Editors_Pain_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Dónde te duele?`)
};

const pt_pt2_profile_editors_pain_title = /** @type {(inputs: Profile_Editors_Pain_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde dói?`)
};

const fr_fr2_profile_editors_pain_title = /** @type {(inputs: Profile_Editors_Pain_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Où as-tu mal ?`)
};

const de_de2_profile_editors_pain_title = /** @type {(inputs: Profile_Editors_Pain_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wo tut es weh?`)
};

const it_it2_profile_editors_pain_title = /** @type {(inputs: Profile_Editors_Pain_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dove fa male?`)
};

/**
* | output |
* | --- |
* | "Where does it hurt?" |
*
* @param {Profile_Editors_Pain_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_title = /** @type {((inputs?: Profile_Editors_Pain_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_title(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_title(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_title(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_title(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_title(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_title(inputs)
	return en_us2_profile_editors_pain_title(inputs)
});
export { profile_editors_pain_title as "profile-editors.pain_title" }